import { callApi } from './api.service';
import { ApiResponse } from '../models/api-response';

const API_URL = import.meta.env.VITE_API_SERVER_URL;

/** The current user's default booking link, or `configured: false` when unset. */
export interface BookingLinkSettings {
  configured: boolean;
  url: string | null;
  provider: string | null;
  provider_label: string | null;
  include_by_default: boolean;
}

export interface BookingLinkUpdate {
  url: string;
  include_by_default?: boolean;
}

const headers = (token: string) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`,
});

export const getBookingLink = async (
  token: string,
): Promise<ApiResponse<BookingLinkSettings>> =>
  callApi<BookingLinkSettings>(`${API_URL}/api/booking-link`, {
    method: 'GET',
    headers: headers(token),
  });

export const updateBookingLink = async (
  token: string,
  data: BookingLinkUpdate,
): Promise<ApiResponse<BookingLinkSettings>> =>
  callApi<BookingLinkSettings>(`${API_URL}/api/booking-link`, {
    method: 'PUT',
    headers: headers(token),
    body: JSON.stringify(data),
  });

export const deleteBookingLink = async (
  token: string,
): Promise<ApiResponse<BookingLinkSettings>> =>
  callApi<BookingLinkSettings>(`${API_URL}/api/booking-link`, {
    method: 'DELETE',
    headers: headers(token),
  });
